import { graphql } from "gatsby";
import React from "react";
import Img from "gatsby-image";

export const query = graphql`
    fragment footer on Language {
        footer {
            addressLine1
            addressLine2
            email
            description
            image {
                childImageSharp {
                    fluid(maxWidth: 400, quality: 85) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            }
            social {
                icon {
                    publicURL
                }
                link
                name
            }
            menu {
                menuItems {
                    title
                    url
                }
            }
        }
    }
`;

const Footer = ({ content }) => {
    const footerMenu = content.menu;

    return (
        <footer className="footer bg-tertiary">
            <div className="container section mx-auto py-10">
                <div className="footer__content">
                    <h3 className="text-lg font-bold mb-4">Contact Info</h3>
                    <ul className="text-sm">
                        <li className="mb-2">
                            <div className="item">
                                <i className="item__icon material-icons text-2xl">
                                    business
                                </i>
                                <div className="item__content">
                                    <p className="item__text">
                                        {content.addressLine1}
                                        <br />
                                        {content.addressLine2}
                                    </p>
                                </div>
                            </div>
                        </li>
                        <li className="mb-2">
                            <div className="item">
                                <i className="item__icon material-icons text-2xl">
                                    email
                                </i>
                                <div className="item__content">
                                    <p className="item__text">
                                        {content.email}
                                    </p>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                {footerMenu !== null && footerMenu !== undefined && (
                    <div className="footer__content">
                        {footerMenu.menuItems.length > 0 && (
                            <h3 className="text-lg font-bold mb-4">Links</h3>
                        )}
                        <ul className="text-sm">
                            {footerMenu.menuItems.map((menu, index) => (
                                <li className="mb-2" key={index}>
                                    <a
                                        className="hover:text-primary"
                                        href={menu.url}
                                    >
                                        {menu.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                )}
                <div className="footer__content">
                    <Img
                        fluid={content.image.childImageSharp.fluid}
                        className="w-40 mb-2"
                    />
                    <p className="mb-3 text-sm">{content.description}</p>
                    <ul className="flex text-sm">
                        {content.social.map((social, index) => (
                            <li className="mb-2 mr-4" key={index}>
                                <a href={social.link}>
                                    <img
                                        className="w-6 h-6"
                                        src={social.icon.publicURL}
                                        alt={social.name}
                                    />
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
